import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-authorizations',
  templateUrl: './authorizations.component.html'
})
export class AuthorizationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
